import useTranslation from 'next-translate/useTranslation';

// Types
import type { PlatformLanguagesType } from '@/types/userType';

// List faq urls
import marketingUrls from '@/lib/urls/marketingUrls';

const useMarketingUrl = () => {
    const { lang } = useTranslation();

    const marketingUrl = (key: keyof typeof marketingUrls) => {
        const userLanguage = lang as PlatformLanguagesType;
        if (key in marketingUrls) {
            const urlSearched = marketingUrls[key];

            if (typeof urlSearched === 'object') {
                if (userLanguage in urlSearched) {
                    return urlSearched[userLanguage];
                }

                return urlSearched.en;
            }

            return urlSearched;
        }

        return 'https://www.iconosquare.com/';
    };

    return { marketingUrl };
};

export default useMarketingUrl;
